import { TimesheetReportTab } from './types';

export const useColumnConfig = ({
  selectedTab,
  projectColumnConfig,
  peopleColumnConfig,
  categoryColumnConfig,
  taskColumnConfig,
  phaseColumnConfig,
}: {
  selectedTab: TimesheetReportTab;
  projectColumnConfig;
  peopleColumnConfig;
  categoryColumnConfig;
  taskColumnConfig;
  phaseColumnConfig;
}) => {
  let columnConfig;

  if (selectedTab === TimesheetReportTab.User) {
    columnConfig = peopleColumnConfig;
  }

  if (selectedTab === TimesheetReportTab.Project) {
    columnConfig = projectColumnConfig;
  }

  if (selectedTab === TimesheetReportTab.Category) {
    columnConfig = categoryColumnConfig;
  }

  if (selectedTab === TimesheetReportTab.Phase) {
    columnConfig = phaseColumnConfig;
  }

  if (selectedTab === TimesheetReportTab.Task) {
    columnConfig = taskColumnConfig;
  }

  return columnConfig;
};
